<script>
import Form from "@/pages/assets/_form.vue";
import Modal from "@/pages/components/modal.vue";

export default {
	components: {Modal, Form},
	emits: ['created:asset', 'updated:asset'],
	props: {
		id: {
			type: String,
			required: true
		},
		assetableType: {
			type: String,
			required: false,
			default: null,
		},
		assetableGroup: {
			type: String,
			required: false,
			default: null,
		},
		accept: {
			type: String,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			index: null,
			modalTitle: 'Bestand toevoegen',
			currentFileName: ''
		}
	},
	mounted() {
		const modalElement = document.getElementById(this.id);
		if (modalElement) {
			modalElement.addEventListener('hidden.bs.modal', this.onModalClose);
		}
	},
	beforeUnmount() {
		const modalElement = document.getElementById(this.id);
		if (modalElement) {
			modalElement.removeEventListener('hidden.bs.modal', this.onModalClose);
		}
	},
	methods: {
		newAsset() {
			this.modalTitle = 'Bestand toevoegen';
			this.currentFileName = '';
			this.index = null;
			this.resetModal();
			this.$refs.assetFormModal.open();
		},
		async editAsset(asset, index) {
			this.index = index;
			this.currentFileName = asset.title || asset.name || '';
			this.modalTitle = `Bestand '${this.currentFileName}' bewerken`;

			await this.$refs.form.setAsset(asset, {
				assetableGroup: this.$props.assetableGroup,
				assetableId: null,
				assetableType: this.$props.assetableType
			});

			this.$refs.assetFormModal.open();
		},
		submit() {
			let data = this.$refs.form.form.data();
			let base64 = data.base64?.base64 ? data.base64 : null;

			let asset = {
				title: data.title,
				metadata: data.metadata
			};

			if (base64) {
				asset = {
					...asset,
					base64: base64.base64,
					name: base64.name,
					size: base64.size,
					type: base64.type,
					lastModified: base64.lastModified
				};
			}

			if (this.index === null) {
				this.$emit('created:asset', {id: null, ...asset});
			} else {
				this.$emit('updated:asset', {index: this.index, asset: asset});
			}

			this.$refs.assetFormModal.close();
		},
		resetModal() {
			this.$refs.form.newAsset({
				assetableGroup: this.$props.assetableGroup,
				assetableId: null,
				assetableType: this.$props.assetableType
			});
		},
		onModalClose() {
			this.index = null;
			this.resetModal();
		}
	}
}
</script>

<template>
	<Modal :id="this.id" ref="assetFormModal" :title="this.modalTitle" size="lg">

		<form :id="this.id + '_form'" @submit.prevent="submit">
			<Form ref="form" :accept="accept"></Form>
		</form>

		<template #footer>
			<span role="button" data-bs-dismiss="modal" class="btn btn-secondary">Annuleren</span>
			<button role="button" type="submit" :form="this.id + '_form'" class="btn btn-primary">Opslaan</button>
		</template>
	</Modal>
</template>
